import React, { Component } from 'react';
import PageTitle from '../../components/PageTitle';
import { connect } from 'react-redux';
import FotaCarActions from '../../redux/FotaCarRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import FotaCarForm from './components/FotaCarForm';
import Blanket from '@atlaskit/blanket';
import isEqual from 'react-fast-compare';
import ContentWrapper from '../../components/ContentWrapper';
import Forbidden from '../../components/Forbidden';
import { withTranslation } from 'react-i18next';
import { EditViewContext } from './components/EditViewContext';

class FotaCarPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      edit: null,
      fotaCar: {
        id: '',
        vin: '',
        iccid: '',
        reference: '',
        firmwareVersion: '',
        bodyType: '',
        year: '',
        configuration: '',
        model: '',
        firmwareStatus: '',
      },
    };
  }

  componentDidMount() {
    const { get } = this.props;
    const requestedId = this.props.match.params.id;
    get(requestedId);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.fetching !== this.props.fetching && prevProps.fetching) {
      if (!this.props.error) {
        if (prevProps.fotaCar && !this.props.fotaCar) {
          // Handle deletion case or other scenarios as needed
        } else if (this.props.match.params.id === 'new' && this.props.fotaCar) {
          //this.props.history.goBack();
        } else if (this.props.fotaCar) {
          this.setState({
            fotaCar: { ...this.props.fotaCar },
            edit: null,
          });
        } else {
          //this.props.history.goBack();
        }
      } else if (!this.state.fotaCar.id) {
        //this.props.history.goBack();
      }
    }
  }

  onFormSubmit = e => {
    e.preventDefault();
    const { update } = this.props;
    const { fotaCar } = this.state;
    let dataForUpdate = {};

    Object.keys(fotaCar).forEach(key => {
      if (!isEqual(fotaCar[key], this.props.fotaCar[key])) {
        dataForUpdate[key] = fotaCar[key];
      }
    });

    if (Object.keys(dataForUpdate).length > 0) {
      update({
        id: this.props.match.params.id,
        data: dataForUpdate,
      });
    }
  };

  onCancel = () => {
    this.setState({
      edit: null,
      fotaCar: { ...this.props.fotaCar },
    });
  };

  onChange = (key, value) => {
    this.setState(prevState => ({
      fotaCar: {
        ...prevState.fotaCar,
        [key]: value,
      },
    }));
  };

  onEditMode = formName => () => {
    if (!this.state.edit) {
      this.setState({edit: formName})
    } else {
      this.setState({edit: null})
    }
  }
  
  render() {
    const { fotaCar, edit } = this.state;
    const {
      fetching,
      dictionaries,
      getDictionaries,
      permissions,
      t,
    } = this.props;

    if (!permissions) {
      return <Forbidden />;
    }

    return (
      <EditViewContext.Provider
        value={{
          edit: this.state.edit,
          permissions: permissions,
          onChangeEditMode: this.onEditMode,
          onChange: this.onChange,
        }}
      >
        <ContentWrapper>
          <PageTitle>{t('fota:Fota Car Details')}</PageTitle>
          <form onSubmit={this.onFormSubmit}>
            <FotaCarForm
              {...fotaCar}
              edit={edit}
              fetching={fetching}
              dictionaries={dictionaries}
              getDictionaries={getDictionaries}
              onCancel={this.onCancel}
              onChange={this.onChange}
            />
          </form>
          <Blanket
            onBlanketClicked={!this.props.allFetching && this.onCancel}
            isTinted={!!edit}
            canClickThrough={!edit}
          />
        </ContentWrapper>
      </EditViewContext.Provider>
    );
  }
}

const mapStateToProps = state => ({
  permissions: state.userProfile.permissions.clients,
  fotaCar: state.fotaCar.data,
  fetching: state.fotaCar.fetching,
  error: state.fotaCar.error,
  dictionaries: state.dictionaries,
  allFetching: state.fotaCar.fetching
});

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(FotaCarActions.fotaCarRequest(id)),
    update: data => dispatch(FotaCarActions.fotaCarUpdateRequest(data)),
    delete: id => dispatch(FotaCarActions.fotaCarDeleteRequest(id)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('fota')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(FotaCarPage));
